import React, { useContext, useState } from "react"
import { Box, MenuItem, Select, TextField } from "@mui/material"
import useStyles from "./settingclasses";
import CommonTypo from "../../components/CommonTypo";
import palette from "../../theme/palette";
import { DropzoneArea } from "material-ui-dropzone";
import ModalCloseIconBlack from "../../assets/images/icon/modalCloseIconBlack";
import CSVFileIcon from "../../assets/images/icon/CSVFileIcon";
import NewButton from "../../components/NewButton";
import { trackingService } from "../../services/tracking";
import { UserTypeContext } from "../../context/userStatus";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'; // Custom icon
const ValidateEmail = (input) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(input)) {
        return true;
    } else {
        return false;
    }
};
const Feedback = ({
    setShowSnakbar,
    setSnakbarMsg,
    setMsgType
}) => {
    const classes = useStyles()
    const { state: outcomeState } =
        useContext(UserTypeContext);
    const [loading, setLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState("request_feature");
    const [files, setFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [requestFeatureState, setRequestFeatureState] = useState({
        featureType: null,
        description: "",
        user_email: "",
    });
    const handleDrop = (acceptedFiles) => {
        setFiles([...files, acceptedFiles]);
    };
    const [requestFeatureErrorState, setRequestFeatureErrorState] = useState({
        featureType: "",
        description: "",
        user_email: "",
    });
    const [reportaBugState, setReportaBugState] = useState({
        bugType: "",
        description: "",
        user_email: "",
    });
    const [reportaBugErrorState, setReportaBugErrorState] = useState({
        bugType: "",
        description: "",
        user_email: "",
    });
    const [feedbackState, setFeedbackState] = useState({
        theme: "",
        description: "",
        user_email: "",
    });
    const [feedbackErrorState, setFeedbackErrorState] = useState({
        theme: "",
        description: "",
        user_email: "",
    });
    const handleOptionChange = (event) => {
        setRequestFeatureState({
            ...requestFeatureState,
            featureType: event.target.value,
        });
    };
    console.log("files", files);

    const handleOptionBugChange = (event) => {
        setReportaBugState({
            ...reportaBugState,
            bugType: event.target.value,
        });
    };
    const handleDragEnter = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = (event) => {
        event.preventDefault();
        setIsDragging(false);
    };
    const handleDropDrag = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            handleDrop(file)
        }
    };
    const giveFeedback = (values) => {
        trackingService
            .giveFeedback(outcomeState.token, {
                ...values,
                uid: localStorage.getItem("userDetails"),
            })
            .then((data) => {
                setMsgType("success");
                setShowSnakbar(true);
                setSnakbarMsg(data.description);
                setFeedbackState({
                    theme: "",
                    description: "",
                    user_email: "",
                });
                setFeedbackErrorState({
                    theme: "",
                    description: "",
                    user_email: "",
                });
            });
    };
    const reportabug = (values) => {
        const formData = new FormData();
        formData.append("photo", files[0]);
        trackingService
            .reportabug(outcomeState.token, formData, {
                ...values,
                uid: localStorage.getItem("userDetails"),
            })
            .then((data) => {
                setMsgType("success");
                setShowSnakbar(true);
                setSnakbarMsg(data.description);
                setReportaBugState({
                    bugType: "",
                    description: "",
                    user_email: "",
                });
                setFiles([]);
                setReportaBugErrorState({
                    bugType: "",
                    description: "",
                    user_email: "",
                });
                setFiles([]);
            });
    };
    const requestAFeature = (values) => {
        trackingService
            .requestafeature(outcomeState.token, {
                ...values,
                uid: localStorage.getItem("userDetails"),
            })
            .then((data) => {
                setMsgType("success");
                setShowSnakbar(true);
                setSnakbarMsg(data.description);
                setRequestFeatureState({
                    featureType: "",
                    description: "",
                    user_email: "",
                });
                setRequestFeatureErrorState({
                    featureType: "",
                    description: "",
                    user_email: "",
                });
            });
    };
    return <Box display={"flex"} flexDirection={"column"} width={"100%"} flex={1} gap={"24px"}>
        <div className={classes.tabBox}>
            <Box className={classes.tabClasses} onClick={() => {
                setSelectedTab("request_feature")
            }} sx={{
                background: selectedTab === "request_feature" ? palette.common.white : "transparent",
            }}>
                <CommonTypo size={16} color="#3E4240" fontWeight={selectedTab === "request_feature" ? 600 : 400}>Request feature</CommonTypo>
            </Box>
            <Box className={classes.tabClasses} onClick={() => {
                setSelectedTab("bug_report")
            }} sx={{
                background: selectedTab === "bug_report" ? palette.common.white : "transparent"
            }}>
                <CommonTypo size={16} color="#3E4240" fontWeight={selectedTab === "bug_report" ? 600 : 400}>Report bug</CommonTypo>
            </Box>
            <Box className={classes.tabClasses} onClick={() => {
                setSelectedTab("give_feedback")
            }} sx={{
                background: selectedTab === "give_feedback" ? palette.common.white : "transparent"
            }}>
                <CommonTypo size={16} color="#3E4240" fontWeight={selectedTab === "give_feedback" ? 600 : 400}>Give feedback</CommonTypo>
            </Box>
        </div>
        {selectedTab === "request_feature" && (
            <Box display={"flex"} flexDirection={"column"} flex={1} width={"100%"} gap={"16px"}>
                <TextField
                    sx={{
                        border: "1px solid var(--color-border)",
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        height: "50px",
                        "& .MuiInputBase-root": {
                            borderRadius: "12px !important",
                            height: "48px",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-primary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiSelect-select": {
                                alignItems: "center",
                                display: "inline-flex"
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        }
                    }}
                    fullWidth
                    select
                    SelectProps={{
                        IconComponent: KeyboardArrowDownIcon, // Replace with your custom icon
                        displayEmpty: true,
                    }}
                    value={requestFeatureState.featureType || ""}
                    onChange={handleOptionChange}
                    error={Boolean(requestFeatureErrorState.featureType)}
                    helperText={requestFeatureErrorState.featureType}
                >
                    <MenuItem value="" disabled>
                        Describe the theme
                    </MenuItem>
                    <MenuItem value={10}>Option 1</MenuItem>
                    <MenuItem value={20}>Option 2</MenuItem>
                    <MenuItem value={30}>Option 3</MenuItem>
                </TextField>
                <TextField
                    placeholder="Your e-mail adress"
                    value={requestFeatureState.user_email}
                    onChange={(e) => {
                        setRequestFeatureState({
                            ...requestFeatureState,
                            user_email: e.target.value,
                        });
                        if (e.target.value) {
                            const validatEmail = ValidateEmail(e.target.value);
                            if (!validatEmail) {
                                setRequestFeatureErrorState({
                                    ...requestFeatureErrorState,
                                    user_email: "Please enter proper email",
                                });
                            } else {
                                setRequestFeatureErrorState({
                                    ...requestFeatureErrorState,
                                    user_email: "",
                                });
                            }
                        } else {
                            setRequestFeatureErrorState({
                                ...requestFeatureErrorState,
                                user_email: "Email required",
                            });
                        }
                    }}
                    sx={{
                        
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        "& .MuiInputBase-root": {
                            border: "1px solid var(--color-border)",
                            borderRadius: "12px !important",
                            height: "50px",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                height: "50px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-secondary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        }
                    }}
                    error={Boolean(requestFeatureErrorState.user_email)}
                    helperText={requestFeatureErrorState.user_email}
                // variant="outlined"
                // fullWidth
                // sx={{ mt: 0 }}
                // rows={5}
                />
                <TextField
                    placeholder="Describe feature functionality"
                    variant="outlined"
                    fullWidth
                    multiline
                    // maxRows={7}
                    // minRows={3}
                    rows={7}
                    sx={{
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        "& .MuiInputBase-root": {
                            border: "1px solid var(--color-border)",
                            borderRadius: "12px !important",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-secondary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        },
                        "& .MuiOutlinedInput-root": {
                            padding: "14px 8px"
                        }
                    }}
                    value={requestFeatureState.description}
                    onChange={(e) => {
                        setRequestFeatureState({
                            ...requestFeatureState,
                            description: e.target.value,
                        });
                        if (e.target.value) {
                            setRequestFeatureErrorState({
                                ...requestFeatureErrorState,
                                description: "",
                            });
                        } else {
                            setRequestFeatureErrorState({
                                ...requestFeatureErrorState,
                                description: "Description is required",
                            });
                        }
                    }}
                    error={Boolean(requestFeatureErrorState.description)}
                    helperText={requestFeatureErrorState.description}
                />
                <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                    <NewButton
                        buttonText={"Send"}
                        variant="contained"
                        onClick={() =>
                            requestAFeature({
                                ...requestFeatureState,
                            })
                        }
                        boxSx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "40px",
                            padding: "16px"
                        }}
                        typographySx={{
                            fontSize: "16px !important",
                            color: "var(--color-text-primary)",
                            fontWeight: `600 !important`
                        }}
                        isLoadong={loading}
                        isDisabled={
                            Boolean(requestFeatureErrorState.user_email) ||
                            Boolean(requestFeatureErrorState.description) ||
                            Boolean(requestFeatureErrorState.featureType) ||
                            !Boolean(requestFeatureState.user_email) ||
                            !Boolean(requestFeatureState.description) ||
                            !Boolean(requestFeatureState.featureType)
                        }
                    />
                </Box>
            </Box>
        )}
        {selectedTab === "bug_report" && (
            <Box display={"flex"} flexDirection={"column"} flex={1} width={"100%"} gap={"16px"}>
                <TextField
                    sx={{
                        border: "1px solid var(--color-border)",
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        height: "50px",
                        "& .MuiInputBase-root": {
                            borderRadius: "12px !important",
                            height: "48px",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-primary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiSelect-select": {
                                alignItems: "center",
                                display: "inline-flex"
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        }
                    }}
                    SelectProps={{
                        IconComponent: KeyboardArrowDownIcon, // Replace with your custom icon
                        displayEmpty: true,
                    }}
                    fullWidth
                    select
                    placeholder="Describe the theme"
                    value={reportaBugState.bugType || ""}
                    onChange={handleOptionBugChange}
                    error={Boolean(reportaBugErrorState.bugType)}
                    helperText={reportaBugErrorState.bugType}
                >
                    <MenuItem value="" disabled>
                        Describe the theme
                    </MenuItem>
                    <MenuItem value={10}>Option 1</MenuItem>
                    <MenuItem value={20}>Option 2</MenuItem>
                    <MenuItem value={30}>Option 3</MenuItem>
                </TextField>
                <TextField
                    placeholder="Your e-mail adress"
                    value={reportaBugState.user_email}
                    onChange={(e) => {
                        setReportaBugState({
                            ...reportaBugState,
                            user_email: e.target.value,
                        });
                        if (e.target.value) {
                            const validatEmail = ValidateEmail(e.target.value);
                            if (!validatEmail) {
                                setReportaBugErrorState({
                                    ...reportaBugErrorState,
                                    user_email: "Please enter proper email",
                                });
                            } else {
                                setReportaBugErrorState({
                                    ...reportaBugErrorState,
                                    user_email: "",
                                });
                            }
                        } else {
                            setReportaBugErrorState({
                                ...reportaBugErrorState,
                                user_email: "Email required",
                            });
                        }
                    }}
                    sx={{
                        
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        "& .MuiInputBase-root": {
                            border: "1px solid var(--color-border)",
                            borderRadius: "12px !important",
                            height: "50px",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                height: "50px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-secondary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        }
                    }}
                    error={Boolean(reportaBugErrorState.user_email)}
                    helperText={reportaBugErrorState.user_email}
                // variant="outlined"
                // fullWidth
                // sx={{ mt: 0 }}
                // rows={5}
                />
                <TextField
                    placeholder="Describe feature functionality"
                    variant="outlined"
                    fullWidth
                    multiline
                    // maxRows={7}
                    // minRows={3}
                    rows={7}
                    sx={{
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        "& .MuiInputBase-root": {
                            border: "1px solid var(--color-border)",
                            borderRadius: "12px !important",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-secondary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        },
                        "& .MuiOutlinedInput-root": {
                            padding: "14px 8px"
                        }
                    }}
                    value={reportaBugState.description}
                    onChange={(e) => {
                        setReportaBugState({
                            ...reportaBugState,
                            description: e.target.value,
                        });
                        if (e.target.value) {
                            setReportaBugErrorState({
                                ...reportaBugErrorState,
                                description: "",
                            });
                        } else {
                            setReportaBugErrorState({
                                ...reportaBugErrorState,
                                description: "Description is required",
                            });
                        }
                    }}
                    error={Boolean(reportaBugErrorState.description)}
                    helperText={reportaBugErrorState.description}
                />
                <Box sx={{
                    width: '100%',
                    height: '60px',
                    borderRadius: '12px',
                    border: isDragging ? '2px dashed var(--primary-color)' : '2px dashed var(--color-border)',
                    display: 'flex',
                    padding: "24px",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    position: 'relative',
                    gap: "16px",
                    backgroundColor: isDragging ? 'rgb(17 115 74 / 20%)' : 'transparent',
                }} onDragEnter={handleDragEnter}
                    onDragOver={(event) => event.preventDefault()}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDropDrag}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: "center",
                        justifyContent: 'space-between',
                        width: '100%',
                    }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: "center",
                            justifyContent: 'flex-start',
                        }}>
                            <CommonTypo size={14} lineHeight={16} >Drag & drop or</CommonTypo> &nbsp;
                            <CommonTypo size={14} lineHeight={16} color="var(--color-new-main)">choose file</CommonTypo>
                        </Box>
                        <CommonTypo size={14} lineHeight={16} color="var(--color-text-primary)"> 10MB maximum</CommonTypo>
                    </Box>

                    <input
                        type="file"
                        accept="image/*"
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            cursor: 'pointer',
                        }}
                        onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                                handleDrop(file)
                            }
                        }}
                    />
                </Box>
                {files && files.length > 0 && files.map(file => {
                    return <Box sx={{
                        width: '100%',
                        height: '60px',
                        borderRadius: '12px',
                        background: "#F4F4F6",
                        padding: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: 'relative',
                        gap: "16px",
                    }} >
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            position: 'relative',
                            gap: "8px",
                        }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.5 16.875C4.5 17.6878 5.01469 18.375 5.625 18.375C5.75535 18.3707 5.88348 18.34 6.0016 18.2848C6.11973 18.2295 6.2254 18.1508 6.31219 18.0534C6.51856 17.8379 6.80211 17.7131 7.10047 17.7066C7.39883 17.7001 7.68755 17.8124 7.90313 18.0187C8.1187 18.2251 8.24346 18.5087 8.24996 18.807C8.25647 19.1054 8.14418 19.3941 7.93781 19.6097C7.64182 19.9276 7.28398 20.1816 6.88627 20.3562C6.48855 20.5308 6.05934 20.6223 5.625 20.625C3.76406 20.625 2.25 18.9375 2.25 16.875C2.25 14.8125 3.76406 13.125 5.625 13.125C6.05934 13.1277 6.48855 13.2192 6.88627 13.3938C7.28398 13.5684 7.64182 13.8224 7.93781 14.1403C8.14418 14.3559 8.25647 14.6446 8.24996 14.943C8.24346 15.2413 8.1187 15.5249 7.90313 15.7313C7.68755 15.9376 7.39883 16.0499 7.10047 16.0434C6.80211 16.0369 6.51856 15.9121 6.31219 15.6966C6.2254 15.5992 6.11973 15.5205 6.0016 15.4652C5.88348 15.41 5.75535 15.3793 5.625 15.375C5.01469 15.375 4.5 16.0603 4.5 16.875ZM13.6416 16.3397C13.1606 16.0162 12.5794 15.8484 12.0666 15.7003C11.8153 15.6324 11.5678 15.5513 11.325 15.4575C11.5547 15.3469 12.2353 15.3356 12.8316 15.4884C13.1201 15.5646 13.4271 15.5231 13.685 15.373C13.943 15.2228 14.1307 14.9764 14.2069 14.6878C14.2831 14.3993 14.2415 14.0923 14.0914 13.8343C13.9413 13.5764 13.6948 13.3887 13.4062 13.3125C13.0371 13.2215 12.6606 13.1632 12.2812 13.1381C11.3503 13.0763 10.5938 13.2394 10.0219 13.6228C9.74306 13.81 9.50878 14.0561 9.3356 14.3438C9.16242 14.6316 9.05457 14.9538 9.01969 15.2878C8.91656 16.1072 9.25219 16.8131 9.9675 17.2744C10.4156 17.5641 10.9388 17.715 11.4441 17.8612C11.7253 17.9447 12.1884 18.0769 12.3703 18.1922C12.3677 18.2155 12.3607 18.238 12.3497 18.2587C12.2222 18.4041 11.4525 18.4266 10.8131 18.2531C10.5284 18.1809 10.2267 18.2229 9.97256 18.3702C9.7184 18.5174 9.53191 18.7582 9.45295 19.0412C9.37398 19.3241 9.40881 19.6267 9.54998 19.8843C9.69115 20.1419 9.92747 20.334 10.2084 20.4197C10.7038 20.553 11.2142 20.622 11.7272 20.625C12.3337 20.625 13.0153 20.5153 13.5778 20.1422C13.8626 19.9539 14.1023 19.7049 14.2798 19.4132C14.4573 19.1215 14.5681 18.7942 14.6044 18.4547C14.7188 17.5809 14.3737 16.8309 13.6416 16.3378V16.3397ZM20.25 13.1887C19.9688 13.0897 19.6598 13.1064 19.3908 13.235C19.1218 13.3637 18.915 13.5939 18.8156 13.875L18 16.1531L17.1844 13.875C17.1403 13.7294 17.0672 13.5942 16.9694 13.4777C16.8716 13.3611 16.7512 13.2656 16.6155 13.197C16.4797 13.1283 16.3314 13.0878 16.1796 13.0781C16.0278 13.0684 15.8756 13.0895 15.7322 13.1403C15.5888 13.191 15.4571 13.2704 15.3453 13.3735C15.2334 13.4765 15.1436 13.6013 15.0813 13.74C15.019 13.8788 14.9854 14.0288 14.9828 14.1809C14.9801 14.333 15.0083 14.4841 15.0656 14.625L16.9406 19.875C17.0187 20.0935 17.1624 20.2824 17.352 20.416C17.5417 20.5497 17.768 20.6214 18 20.6214C18.232 20.6214 18.4583 20.5497 18.648 20.416C18.8376 20.2824 18.9813 20.0935 19.0594 19.875L20.9344 14.625C21.0341 14.3438 21.018 14.0345 20.8896 13.7651C20.7613 13.4958 20.5312 13.2885 20.25 13.1887ZM3.375 10.125V3.75C3.375 3.25272 3.57254 2.77581 3.92417 2.42418C4.27581 2.07254 4.75272 1.875 5.25 1.875H14.25C14.3978 1.87488 14.5441 1.90389 14.6807 1.96035C14.8173 2.01681 14.9414 2.09962 15.0459 2.20406L20.2959 7.45406C20.4004 7.55862 20.4832 7.68272 20.5397 7.81929C20.5961 7.95586 20.6251 8.10222 20.625 8.25V10.125C20.625 10.4234 20.5065 10.7095 20.2955 10.9205C20.0845 11.1315 19.7984 11.25 19.5 11.25C19.2016 11.25 18.9155 11.1315 18.7045 10.9205C18.4935 10.7095 18.375 10.4234 18.375 10.125V9.75H13.875C13.5766 9.75 13.2905 9.63147 13.0795 9.4205C12.8685 9.20952 12.75 8.92337 12.75 8.625V4.125H5.625V10.125C5.625 10.4234 5.50647 10.7095 5.2955 10.9205C5.08452 11.1315 4.79837 11.25 4.5 11.25C4.20163 11.25 3.91548 11.1315 3.7045 10.9205C3.49353 10.7095 3.375 10.4234 3.375 10.125ZM15 7.5H17.1562L15 5.34375V7.5Z" fill="black" />
                            </svg>

                            <CommonTypo size={14} lineHeight={16} >{file.name}</CommonTypo>
                        </Box>

                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                        }} onClick={() => {
                            setFiles([...files].filter(fil => fil !== file));
                        }}>
                            <ModalCloseIconBlack color={"var(--color-text-primary)"} />
                        </Box>
                    </Box>
                })}
                <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                    <NewButton
                        buttonText={"Send"}
                        variant="contained"
                        onClick={() =>
                            reportabug({
                                ...reportaBugState,
                            })
                        }
                        boxSx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "40px",
                            padding: "16px"
                        }}
                        typographySx={{
                            fontSize: "16px !important",
                            color: "var(--color-text-primary)",
                            fontWeight: `600 !important`
                        }}
                        isLoadong={loading}
                        isDisabled={
                            Boolean(reportaBugErrorState.user_email) ||
                            Boolean(reportaBugErrorState.description) ||
                            Boolean(reportaBugErrorState.bugType) ||
                            !Boolean(reportaBugState.user_email) ||
                            !Boolean(reportaBugState.description) ||
                            !Boolean(reportaBugState.bugType)
                        }
                    />
                </Box>
            </Box>
        )}
        {selectedTab === "give_feedback" && (
            <Box display={"flex"} flexDirection={"column"} flex={1} width={"100%"} gap={"16px"}>
                <TextField
                    sx={{
                        border: "1px solid var(--color-border)",
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        height: "50px",
                        "& .MuiInputBase-root": {
                            borderRadius: "12px !important",
                            height: "48px",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-primary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        }
                    }}
                    fullWidth
                    placeholder="Describe the theme"
                    value={feedbackState.theme}
                    onChange={(e) => {
                        setFeedbackState({
                            ...feedbackState,
                            theme: e.target.value,
                        });
                        if (e.target.value) {
                            setFeedbackErrorState({
                                ...feedbackErrorState,
                                theme: "",
                            });
                        } else {
                            setFeedbackErrorState({
                                ...feedbackErrorState,
                                theme: "Theme is required",
                            });
                        }
                    }}
                    error={Boolean(feedbackErrorState.theme)}
                    helperText={feedbackErrorState.theme}
                />
                <TextField
                    placeholder="Your e-mail adress"
                    value={feedbackState.user_email}
                    onChange={(e) => {
                        setFeedbackState({
                            ...feedbackState,
                            user_email: e.target.value,
                        });
                        if (e.target.value) {
                            const validatEmail = ValidateEmail(e.target.value);
                            if (!validatEmail) {
                                setFeedbackErrorState({
                                    ...feedbackErrorState,
                                    user_email: "Please enter proper email",
                                });
                            } else {
                                setFeedbackErrorState({
                                    ...feedbackErrorState,
                                    user_email: "",
                                });
                            }
                        } else {
                            setFeedbackErrorState({
                                ...feedbackErrorState,
                                user_email: "Email required",
                            });
                        }
                    }}
                    sx={{
                        
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        "& .MuiInputBase-root": {
                            borderRadius: "12px !important",
                            height: "50px",
                            border: "1px solid var(--color-border)",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                height: "50px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-secondary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        }
                    }}
                    error={Boolean(feedbackErrorState.user_email)}
                    helperText={feedbackErrorState.user_email}
                // variant="outlined"
                // fullWidth
                // sx={{ mt: 0 }}
                // rows={5}
                />
                <TextField
                    placeholder="Describe feature functionality"
                    variant="outlined"
                    fullWidth
                    multiline
                    // maxRows={7}
                    // minRows={3}
                    rows={7}
                    sx={{
                        alignSelf: "stretch",
                        borderRadius: "12px",
                        marginBottom: "0px !important",
                        "& .MuiInputBase-root": {
                            border: "1px solid var(--color-border)",
                            borderRadius: "12px !important",
                            "& .MuiInputBase-input": {
                                borderRadius: "12px",
                                padding: "16px !important",
                                "&::placeholder": {
                                    color: "var(--color-text-secondary)",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                display: "none"
                            }
                        },
                        "& .MuiOutlinedInput-root": {
                            padding: "14px 8px"
                        }
                    }}
                    value={feedbackState.description}
                    onChange={(e) => {
                        setFeedbackState({
                            ...feedbackState,
                            description: e.target.value,
                        });
                        if (e.target.value) {
                            setFeedbackErrorState({
                                ...feedbackErrorState,
                                description: "",
                            });
                        } else {
                            setFeedbackErrorState({
                                ...feedbackErrorState,
                                description: "Description is required",
                            });
                        }
                    }}
                    error={Boolean(feedbackErrorState.description)}
                    helperText={feedbackErrorState.description}
                />
                <Box display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                    <NewButton
                        buttonText={"Send"}
                        variant="contained"
                        onClick={() =>
                            giveFeedback({
                                ...feedbackState,
                            })
                        }
                        boxSx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "40px",
                            padding: "16px"
                        }}
                        typographySx={{
                            fontSize: "16px !important",
                            color: "var(--color-text-primary)",
                            fontWeight: `600 !important`
                        }}
                        isLoadong={loading}
                        isDisabled={
                            Boolean(feedbackErrorState.user_email) ||
                            Boolean(feedbackErrorState.description) ||
                            Boolean(feedbackErrorState.theme) ||
                            !Boolean(feedbackState.user_email) ||
                            !Boolean(feedbackState.description) ||
                            !Boolean(feedbackState.theme)
                        }
                    />
                </Box>

            </Box>
        )}

    </Box>
}

export default Feedback